import {Component} from 'react';
import PropTypes from 'prop-types';
import {Button} from 'semantic-ui-react';

export default class LoadMoreButton extends Component {
  static propTypes = {
    comparables: PropTypes.object.isRequired,
    onClick: PropTypes.func.isRequired,
  };

  render() {
    const {comparables, onClick} = this.props;
    const {pagination: {page, totalPages}} = comparables;
    const hasMorePages = page + 1 < totalPages;
    return (hasMorePages && <Button secondary basic className="load-more-button" content="Load More" onClick={onClick}/>);
  }
}